import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import {getAllDepotList} from "@/api/sms/arrival-order";

export default extend(dialog, {
	namespaced: true,
	state: {
		form: {},
		depotList: []
	},
	actions: {
		async afterOpenDialog({ dispatch, commit }, payload) {
			await wait(dispatch, 'sms.warup.import-stock', async function() {
				const response = await getAllDepotList();
				if (response.data) {
					commit('save', {
						depotList: response.data
					})
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/sms/warup/import-stock.js